<div class="modal-header ">
    <strong class="text-primary bold fs-5 d-inline-block">{{prefix}} สิทธิหลัก (MAININSCL)</strong>
</div>
<form #form="ngForm" class="form-validate">
  <div class="modal-body">
      <div class="mb-3 row">
          <label for="rightId" class="col-xl-2 ps-xl-4 col-form-label ui-require text-end">รหัสสิทธิ</label>
          <div class="col-xl-3">
              <input type="text" id="rightId" name="rightId" class="form-control" [(ngModel)]="right.rightId"
                     [maxlength]="3"
                     [class.is-invalid]="errors['rightId']"
              placeholder="กรุณาระบุ 3 ตัวอักษร">
            <div class="invalid-feedback">{{errors['rightId']}}</div>
          </div>
          <label for="rightName" class="col-xl-2 ps-xl-4 col-form-label ui-require text-end">ชื่อสิทธิ</label>
          <div class="col-xl-3">
              <input type="text" id="rightName" name="rightName" class="form-control" [(ngModel)]="right.rightName"
                     [class.is-invalid]="errors['rightName']">
            <div class="invalid-feedback">{{errors['rightName']}}</div>
          </div>
      </div>
      <div class="mb-3 row">
          <label for="rightOrder" class="col-xl-2 ps-xl-4 col-form-label  text-end">RIGHT_ORDER</label>
          <div class="col-xl-3">
              <input type="text" id="rightOrder" name="rightOrder" class="form-control" digitOnly [(ngModel)]="right.rightOrder">
          </div>
          <label for="rightMain" class="col-xl-2 ps-xl-4 col-form-label ui-require text-end">RIGHT_MAIN</label>
          <div class="col-xl-3">
              <input type="text" id="rightMain" name="rightMain" class="form-control" maxlength="1" [(ngModel)]="right.rightMain"
                     [class.is-invalid]="errors['rightMain']">
            <div class="invalid-feedback">{{errors['rightMain']}}</div>
          </div>
      </div>
      <div class="mb-3 row">
          <label for="rightDesc" class="col-xl-2 ps-xl-4 col-form-label  text-end">รายละเอียดสิทธิ</label>
        <div class="col-xl-8">
          <div class="col-auto">
              <textarea id="rightDesc" name="rightDesc" class="form-control" rows="5"
                        maxlength="200" [(ngModel)]="right.rightDesc"></textarea>
          </div>
        </div>
      </div>
      <div class="mb-3 row">
        <label for="remark" class="col-xl-2 col-form-label text-end ui-require">REMARK</label>
        <div class="col-xl-8">
          <div class="col-auto">
              <textarea id="remark" name="remark"  required
                        class="form-control" rows="5" maxlength="300" [(ngModel)]="right.remark"></textarea>
          </div>
        </div>
      </div>
      <div class="mb-3 row">
        <label for="source" class="col-xl-2 col-form-label text-end">SOURCE</label>
        <div class="col-xl-3">
          <input type="text" id="source" name="source" class="form-control" [(ngModel)]="right.source">
        </div>
        <label for="status" class="col-xl-2 col-form-label text-end ui-require">สถานะ</label>
        <div class="col-xl-3">
          <div class="col-auto">
            <select class="form-select" id="status" name="status" [(ngModel)]="right.used" required #status="ngModel">
              <option selected [ngValue]="'Y'">ใช้งาน</option>
              <option [ngValue]="'N'">ยกเลิก</option>
            </select>
            @if (status.invalid && (status.dirty || status.touched)) {
              <custom-error *ngIf="status.hasError('required')" error="*จำเป็น"></custom-error>
            }
          </div>
        </div>
      </div>
  </div>
</form>
<div class="row mt-3 mb-3">
    <div class="col-12 text-end">
        <button type="button" class="btn btn-primary custom-button mx-1 btn-main confirm-btn" (click)="save()">
            {{prefix}} สิทธิหลัก (MAININSCL)
        </button>
        <button type="button" class="btn btn-default custom-button mx-1 btn-main confirm-btn" (click)="activeModal.close()">ปิด</button>

    </div>
</div>
